// Configuration for external video assets
import { getConfiguration } from '../services/api';

const videoConfig = {
  // Video URL will be loaded from configuration with key CMS_PROMO_VIDEO
  promoVideo: "",
  
  // Poster image for the video
  posterImage: "/assets/default-logo.jpg"
};

// Load video configuration from the database
export const loadVideoConfig = async (): Promise<void> => {
  // Get promo video from configuration table with key CMS_PROMO_VIDEO
  const promoVideo = await getConfiguration('CMS_PROMO_VIDEO', "");
  videoConfig.promoVideo = promoVideo;
};

export default videoConfig;